module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/featured_feature-e7dd7b7ef3cb813db69de38698cfcc59.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/featured_feature.png
// module id = 1592
// module chunks = 0